import { ChartColorMappings, LayeredChartSpec } from "@hex/common";
import { Literal, Record as RRecord, Static, Unknown } from "runtypes";
export const CellCopyPayload = RRecord({
  hexCopyType: Literal("projectCells"),
  payload: Unknown,
});
export type CellCopyPayload = Static<typeof CellCopyPayload>;

export const ChartStyleCopyPayload = RRecord({
  hexCopyType: Literal("chartStyle"),
  style: LayeredChartSpec,
  styleColorMappings: ChartColorMappings,
});
export type ChartStyleCopyPayload = Static<typeof ChartStyleCopyPayload>;
